import variables from '@/styles/element-vars.scss';
import defaultSettings from '@/settings';

const { showSettings, fixedHeader, sidebarLogo, locale } = defaultSettings;

const state = {
    theme: variables.theme,
    showSettings: showSettings,
    fixedHeader: fixedHeader,
    sidebarLogo: sidebarLogo,
    locale: locale
};

const mutations = {
    // eslint-disable-next-line
    changedSetting: (state, { key, value }) => {
        if (state.hasOwnProperty(key)) {
            state[key] = value;
        }
    }
};

const actions = {
    changeSetting({ commit }, data) {
        commit('changedSetting', data);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
